<template>
  <div class="flex flex-row h-auto w-full justify-between">
    <div class="flex flex-col h-auto w-[32%]" v-for="option in options" :key="option.id">
      <input class="hidden peer" type="radio" :id="option.id" :value="option.id" :checked="modoFormulario === option.id"
        @click="setmodoFormulario(option.id)" />

      <label :for="option.id" :class="[
        'container flex flex-col w-full h-[5rem] md:h-[6rem] items-center justify-center rounded-md transition-all cursor-pointer hover:bg-ROJO_LEON hover:text-white',
        modoFormulario === option.id
          ? 'bg-ROJO_LEON text-white'
          : 'bg-GRIS_BUTTONS text-black',
      ]">
        <div class="flex flex-col w-full h-full items-center justify-center gap-1 px-4 py-2">
          <img class="w-4 md:w-6 h-auto transition-all fill-color" alt="" :src="option.icon" :class="[
            modoFormulario === option.id
              ? 'filter-selected'
              : 'filter-default',
          ]" />
          <span class="w-auto text-xs md:text-sm h-auto font-semibold text-center leading-tight">{{ option.label }}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["selectedOption"]);

const LOCAL = 5;
const modoFormulario = ref(LOCAL);

const options = ref([
  {
    id: 5,
    value: "local",
    label: "Instalación en local",
    icon: "/img/home/battery/store_icon.svg",
  },
  {
    id: 4,
    value: "home",
    label: "Instalación a domicilio",
    icon: "/img/home/battery/home_icon.svg",
  },
  {
    id: 6,
    value: "rescue",
    label: "Servicio de rescate",
    icon: "/img/home/battery/alert_icon.svg",
  },
]);

const setmodoFormulario = (value) => {
  modoFormulario.value = value;
  emit("selectedOption", value);
};
</script>

<style>
.filter-default {
  filter: grayscale(100%) brightness(0);
}

.filter-selected {
  filter: grayscale(100%) brightness(0) invert(100%);
}

.peer-hover:filter-hover {
  filter: grayscale(100%) brightness(0) invert(100%);
}

.container:hover .fill-color {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(2427%) hue-rotate(115deg) brightness(118%) contrast(99%) !important;
}

.no-hover:hover .fill-color {
  filter: grayscale(100%) brightness(0) !important;
}
</style>
